export default __webpack_public_path__ + "static/people_coming_soon-3426ad14bd1ff0b8df8a3483a0b7c6fe.jpg";